/* eslint-disable */
/* GENERATED BY DECAFFEINATE */

// ----------------------------------
// Handles generic form functionality
// Paired with styles from form.scss
// ==================================
import $ from "jquery";

let textInputs = `input[type="email"], input[type="number"],   input[type="password"], input[type="search"], \
input[type="tel"],   input[type="text"],	 input[type="url"],	  input[type="color"], \
input[type="date"],  input[type="datetime"], input[type="week"],	 input[type="datetime-local"], \
input[type="month"], input[type="time"],	 textarea:not(.clone),   input:not([type])`;

let elementOrId = el =>
	$(typeof el === "string" ? document.getElementById(el) : el);

// ----------------------------------
// OkForm class definition
// ==================================
class OkForm {
	static initClass() {
		this.prototype.form = null;
		this.prototype.errors = {};
	}
	constructor(form) {
		this.form = elementOrId(form);
		this.init();
	}

	// Binds events to various inputs.
	init() {
		let start = new Date().getTime();
		// Don't initialize after the first time.
		if (this.form.hasClass("initialized")) {
			return;
		}

		let okform = this;
		this.form.addClass("okform");

		// Text & select inputs need to be given container, message, and icon markup.
		this.form.find(textInputs + ", select").each(function() {
			let classes = `inputcontainer ${this.tagName.toLowerCase()}`;
			if ($(this).attr("class")) {
				classes += ` ${$(this).attr("class")}`;
			}
			$(this).wrap(`<div id='${this.id}Container' class='${classes}'/>`);
			$(this)
				.parent()
				.append(
					'<span class="okform-feedback message empty" style="height: 0"/>'
				);
			return $(this).parent().append('<div class="icon okicon"/>');
		});

		this.form.find(textInputs).each(function() {
			let $this = $(this);
			let $container = $this.parent();
			// Add a class for empty inputs
			$this.bind("input propertychange", () => {
				if ($this.val().length > 0) {
					return $container.removeClass("empty");
				} else {
					return $container.addClass("empty");
				}
			});
			$this.trigger("input");

			// Add a clear button to some inputs
			if ($this.hasClass("clearval")) {
				$container.append('<a href="javascript:void(0)" class="clearbtn"></a>');
				$container.find(".clearbtn").bind("click", () => {
					return $container.find("input").val("").trigger("input").focus();
				});
			}

			// Older browsers don't support placeholders. Pick up their slack.
			if (!okform.placeholderIsSupported()) {
				if ($(this).attr("placeholder")) {
					let placeholder = `<div class='placeholder'>${$(this).attr(
						"placeholder"
					)}</div>`;
					$(this).after(placeholder);
					placeholder = $this.parent().find(".placeholder").first();

					$(placeholder).click(() => {
						return $(this).focus();
					});

					$(this).bind("blur focus", function() {
						if ($(this).val().length > 0 || $(this).is(":focus")) {
							return placeholder.hide();
						} else {
							return placeholder.show();
						}
					});
					// set initial state
					return $(this).trigger("blur");
				}
			}
		});

		// Text areas need to auto-resize as content overflows.
		this.form.find("textarea:not(.clone, .noresize)").each(function() {
			return okform.bindAutoResize($(this));
		});

		// Checkboxes / radios need to set state as a class on the label.
		this.form
			.find('input[type="checkbox"],input[type="radio"]')
			.each(function() {
				okform.setInputLabelState(this.id);
				let label = $(`label[for='${this.id}']:not(.label_only)`);
				label.addClass(this.type);

				// insert an element into the label to hold the checkbox / radio style
				// this is done so we can have labels larger than the checkbox / radio height
				label.prepend("<span class='icon'></span>");

				// move the input itself to be inside the label
				if ($(this).attr("type") === "checkbox") {
					label.prepend($(this));
				}

				// add the "focus" class to the label for keyboard navigation
				$(this).focus(() => label.addClass("focus"));

				$(this).blur(() => label.removeClass("focus"));

				return $(this).change(function() {
					okform.setInputLabelState(this.id);

					// If this was a radio, we need to re-check the state of all other
					// radios in this set.
					if (this.type === "radio") {
						return okform.form
							.find(`input[name='${this.name}']`)
							.each(function() {
								return okform.setInputLabelState(this.id);
							});
					}
				});
			});

		// Select lists need to be replaced for styling. Use Chosen library.
		this.form.find("select").each(function() {
			let $this = $(this);
			let attrs = {
				// Disabling search by default
				disable_search_threshold: 9001,
			};

			if ($(this).attr("multiple")) {
				attrs.disable_search_threshold = 7;
			}
			if ($(this).hasClass("clearbtn")) {
				attrs.allow_single_deselect = true;
			}

			// Calculating width is expensive. Add this class for selects you are
			// certain of their width, and set it in CSS.
			if ($this.hasClass("fixed_width")) {
				attrs.width = 1;
			} else {
				// 20px is the list item padding, plus a little extra or text rendering
				// differences. Chosen fails to consider these.
				attrs.width = $this.outerWidth() + 40 + "px";
			}

			if ($this.hasClass("search")) {
				attrs.disable_search_threshold = 0;
			}

			if ($this.hasClass("search_contains")) {
				attrs.search_contains = true;
			}

			if ($this.hasClass("clearval")) {
				attrs.allow_single_deselect = true;
			}

			let chosen = $this.chosen(attrs).data("chosen");

			// Add a class based on whether or not we're searching.
			if ($this.hasClass("search") && chosen) {
				return chosen.search_field.on("keyup input", () => {
					return chosen.container.toggleClass(
						"chosen-searching",
						!!chosen.search_field.val()
					);
				});
			}
		});

		// Prevent scroll bubbling up to the page in a select list.
		this.form
			.find(".chosen-container .chosen-results")
			.on("mousewheel", function(e, delta) {
				return ScrollHelpers.preventOverscroll($(this));
			});
		// Trigger a native change event on jquery change to trigger any prototype
		// events bound to a select box.
		this.form.find("select").on("change", e => {
			return this.triggerEvent($(e.target), "change");
		});

		/*
	auto-tab inputs!
		requirements:
		* All inputs are siblings
		* All inputs are of type text
		* All inputs have maxlength
		* They're all inside a container with class `autotab`
  */
		this.autotab_inputs = "input[type=number], input[type=text]";
		this.form.find(".autotab").on("keyup", this.autotab_inputs, e => {
			let input = $(e.target);
			let keycode = e.keyCode;
			return this.autoTab(input, keycode);
		});

		// Mark form as initialized
		this.form.addClass("initialized");
		this.form.data("okform", this);
		let end = new Date().getTime();

		return this.listen();
	}

	listen() {
		// Let any bit of javascript trigger a message
		return $(document).on("okform.messageset", (ev, el, msg, status) => {
			return this.setMessage(el, msg, status);
		});
	}

	// ----------------------------------
	// Public use functions
	// ==================================

	// trigger a native javascript event. useful for calling
	// protoype events from jquery.
	//   element   - a jquery object
	//   eventName - the type of event to trigger
	triggerEvent(element, eventName) {
		// keep an infinite loop from happening
		if (this.triggeringEvent) {
			return;
		}
		this.triggeringEvent = true;
		setTimeout(() => {
			return (this.triggeringEvent = null);
		}, 100);

		// safari, webkit, gecko
		if (document.createEvent) {
			let evt = document.createEvent("HTMLEvents");
			evt.initEvent(eventName, true, true);
			return element[0].dispatchEvent(evt);
		}

		// internet explorer
		if (element[0].fireEvent) {
			return element[0].fireEvent(`on${eventName}`);
		}
	}

	addParameter(name, value) {
		return $("<input>")
			.attr({
			type: "hidden",
			name,
			value,
		})
			.appendTo(this.form);
	}

	// Set a message on a text input.
	//  inputEl  - The element or id of the element to set the message on.
	//  msg	  - Message text, can be markup.
	//  status   - Status string, 'error' or 'success'. Optional.
	setMessage(inputEl, msg, status) {
		let input = this.form.find(elementOrId(inputEl));

		if (!input.length) {
			return;
		}

		let container = input.parent();
		let msgElement = container.children(".message").first();

		this.setStatus(input, status);

		// Just using .html() might re-use a text node. Bad if the caller
		// might have passed (and cached) their own.
		msgElement.empty();

		if (msg) {
			msgElement.removeClass("empty");
			return Utilities.transitionContent(msgElement, msg);
		} else {
			return msgElement.addClass("empty").html("").css("height", 0);
		}
	}

	// Resets all errorous form items to their default, messageless state
	resetErrorMessages() {
		return $.each(this.errors, id => {
			return this.setMessage(id, "");
		});
	}

	// Supply a list of suggestions for an errorous text input.
	//   inputEl	 - The element or id of the element to set the message on.
	//   sugs		- Array of suggestions. Suggestion objects can have:
	//	 text		- The text of the suggestion. Required.
	//	 id		  - ID of the suggestion. Optional.
	//   options	 - Array of options:
	//	 message	 - Message to display in header at the top of the options.
	//	 description - Description of what the options are, or what to do.
	createSuggestions(inputEl, sugs, options) {
		let suggestions;
		let input = this.form.find(elementOrId(inputEl));
		if (!input.length || !sugs || sugs.length === 0) {
			return;
		}

		this.setStatus(input, "error");
		let container = input.parent();
		container.addClass("hassuggestions");

		// If the suggestions element doesn't exist, create it.
		if (input.hasClass("append-to-body")) {
			suggestions = $(`#${input.attr("id")}_suggestions .suggestions`);
		} else {
			suggestions = container.find(".suggestions").first();
		}

		if (suggestions.length === 0) {
			if (input.hasClass("append-to-body")) {
				$("body").append(`\
<div id='${input.attr("id")}_suggestions' class='suggestions_body_wrapper'>
	<div class="okform initialized">
		<div class="inputcontainer">
			<div class="suggestions hide">
				<span class="message"><div class="arrow"/></span>
			</div>
		</div>
	</div>
</div>\
`);
				suggestions = $(`#${input.attr("id")}_suggestions .suggestions`);
			} else {
				container.append('<div class="suggestions hide"/>');
				suggestions = container.find(".suggestions").first();
			}

			if (input.hasClass("suggestions-right")) {
				suggestions.addClass("right");
			}
			if (input.hasClass("suggestions-left")) {
				suggestions.addClass("left");
			}
		}

		// Slight timeout to allow for transition. Firefox is a pain about this.
		setTimeout(() => {
			return suggestions.removeClass("hide");
		}, 20);

		// Clear out old suggestions if there were any, add in the initial stuff.
		suggestions.html("");
		if (options.message) {
			suggestions.append(
				`<span class="message">${options.message}<div class="icon"/><div class="arrow"/></span>`
			);
		}
		suggestions.append('<ul class="list"/>');
		let list = suggestions.find(".list").first();
		if (options.description) {
			list.append(`<li class="description">${options.description}</li>`);
		}

		// Add suggestions, bind click handler.
		return (() => {
			let result = [];
			for (let sug of sugs) {
				var el = $("<li>", { className: "suggestion" }).append(
					$("<a>", { id: sug.id }).text(sug.text)
				);
				list.append(el);
				result.push(
					(sug =>
						el.click(e => {
							let event = new $.Event(
								"suggestionselected",
								{
									oldValue: input.val(),
									suggestion: sug,
								},
							);
							input.val(sug.text);
							this.hideSuggestions(input);
							return input.trigger(event);
						}))(sug)
				);
			}
			return result;
		})();
	}

	// Hides the suggestion list added via createSuggestions.
	hideSuggestions(inputEl) {
		let input = this.form.find(elementOrId(inputEl));

		if (!input.length) {
			return;
		}

		this.setStatus(input);
		let container = input.parent();
		container.removeClass("hassuggestions");

		if (input.hasClass("append-to-body")) {
			return $(`#${input.attr("id")}_suggestions`).remove();
		} else {
			let suggestions = container.find(".suggestions").first();
			return suggestions.addClass("hide");
		}
	}

	// Changes a select box value
	setOption(selectEl, value) {
		let select = this.form.find(elementOrId(selectEl));
		if (!select.length) {
			return;
		}
		select.val(value);
		select.trigger("change");
		return select.trigger("chosen:updated.chosen");
	}

	// Fix the order that options are in markup based on what's been selected.
	// Meant for Chosen multi-selects where order is important.
	// selectEl - jQuery select object with chosen
	// returns selectEl's val()
	fixOptionOrder(selectEl) {
		let select = this.form.find(elementOrId(selectEl));
		if (!select.chosen()) {
			return;
		}

		let options = [];
		select.parent().find(".search-choice-close").each((idx, el) => {
			idx = $(el).data("option-array-index");
			return options.push(select.find(`option:eq(${idx})`));
		});
		for (let option of options) {
			select.append(option);
		}
		return select.val();
	}

	// ----------------------------------
	// autotab
	// ==================================

	autoTab(input, key) {
		// do nothing when they hit "tab"
		let { length } = input.val();
		let oldlength = parseInt(input.data("oldlength"), 10) || 0;

		if (oldlength === length) {
			return true;
		}

		input.data("oldlength", length);

		let maxlength = input.attr("maxlength");
		maxlength = parseInt(maxlength, 10);
		if (!maxlength) {
			return;
		}

		// if they hit a character and they hit max length, tab to the next input
		if (length === maxlength) {
			input
				.closest(".inputcontainer")
				.next(".inputcontainer")
				.find(this.autotab_inputs)
				.focus();
		}

		return true;
	}

	// ----------------------------------
	// Utility / internal use functions
	// ==================================

	// Set the status on a text input.
	// input		- jQuery object for the input.
	// status	- 'error', 'success', or null to reset.
	setStatus(input, status) {
		let container = input.parent();
		let removeStatusClasses = function(idx, classes) {
			let matches = classes.match(/status[a-zA-Z0-9]*/g);
			if (matches) {
				return matches.join(" ");
			}
		};

		if (status) {
			// Keep track of errorous inputs
			input.each((i, input) => {
				if (status === "error") {
					return (this.errors[input.id] = $(input));
				} else {
					return delete this.errors[input.id];
				}
			});

			// Remove existing status classes.
			container.removeClass(removeStatusClasses);
			return container.addClass(`status${status}`);
		} else {
			delete this.errors[input.attr("id")];
			return container.removeClass(removeStatusClasses);
		}
	}

	// Set the label for a radio / checkbox to match the state of the input.
	setInputLabelState(inputEl) {
		let input = $(elementOrId(inputEl));
		let label = this.form.find(`label[for="${input[0].id}"]`);
		if (label) {
			if (input.is(":disabled")) {
				label.addClass("disabled");
			} else {
				label.removeClass("disabled");
			}

			if (input.is(":checked")) {
				return label.addClass("checked");
			} else {
				return label.removeClass("checked");
			}
		}
	}

	// Returns true or false if the placeholder attribute is supported.
	placeholderIsSupported() {
		let test = document.createElement("input");
		return test.placeholder != null;
	}

	// Text area auto-resize, adapted from James Padolsey's solution. Clones a
	// text area off-screen and uses it for sizing.
	// http://james.padolsey.com/demos/plugins/jQuery/autoresize.jquery.js/view
	bindAutoResize(textarea) {
		let scrollbarWidth = util.getScrollBarWidth();
		let props = [
			"height",
			"width",
			"lineHeight",
			"textDecoration",
			"letterSpacing",
		];
		let propOb = {};

		// Create object of styles to apply to the clone, for exact reproduction
		$.each(props, (i, prop) => (propOb[prop] = textarea.css(prop)));

		// Clone the actual textarea removing unique properties
		// and insert before original textarea
		let clone = textarea
			.clone()
			.removeAttr("id")
			.removeAttr("name")
			.attr("aria-hidden", "true")
			.css(propOb)
			.attr("tabIndex", "-1")
			.addClass("clone")
			.insertBefore(textarea);

		let lastScrollTop = null;
		let updateSize = function() {
			// Prepare the clone
			clone
				.height(0)
				.width(textarea.width() + scrollbarWidth)
				.val(textarea.val())
				.scrollTop(100000);

			// Find the height of text
			let scrollTop = clone.scrollTop();
			textarea.add(clone);

			// Don't do anything if scrollTop hasen't changed
			if (lastScrollTop === scrollTop) {
				return;
			}
			lastScrollTop = scrollTop;

			// Resize original, but not below original height
			textarea.height(scrollTop);

			// Scroll to bottom, if at bottom (To meet padding)
			let bottomPadding = parseInt(textarea.css("padding-bottom"));
			let lineHeight = parseInt(textarea.css("line-height"));
			textarea.scrollTop(textarea.scrollTop() + bottomPadding + lineHeight);

			// trigger an event indicating that the textarea has resized
			return textarea.trigger({
				type: "autoexpand",
				time: new Date(),
			});
		};

		// Bind resize events
		textarea.bind("keyup keydown input", updateSize);
		return updateSize();
	}
}
OkForm.initClass();

// Bind OkForm to the global scope.
window.OkForm = OkForm;



// WEBPACK FOOTER //
// ./src/legacy/okform.js